import dayjs from 'dayjs';

import { useMember } from 'modules/common/queries/member';
import { useTransactionStartDate } from 'modules/common/queries/transactionStartDate';

/**
 * The date this flow asks for transaction history from, formatted for copy ("Jan 1, 2026").
 *
 * Read from the backend's transaction start date rather than `business.s_corp_election_date`
 * directly: the backend derives it from the election date and already handles the members whose
 * books start elsewhere — retro-S members start at the earlier of their books start and election
 * date — so reading the raw field would ship those members the wrong date.
 *
 * `formattedDate` is null when the member has no start date on file, so callers can fall back to
 * copy without a date instead of rendering "since undefined".
 */
export default function useTransactionHistoryStart() {
    const { data: member, isLoading: isLoadingMember } = useMember();
    const { data, isLoading } = useTransactionStartDate(member?.id);

    return {
        // The backend's own formatted_date is the long form ("January 01, 2026").
        formattedDate: data?.transaction_start_date ? dayjs(data.transaction_start_date).format('MMM D, YYYY') : null,
        isLoading: isLoadingMember || isLoading,
    };
}
